import React, { useState, useEffect } from 'react';

import Module from './Module';
import Lesson from './Lesson';
import QuizAssessment from './QuizAssessment';
import CapstoneProject from './CapstoneProject';
import CodingAssessment from './CodingAssessment';
import Assignment from './Assignment';
import AlmaX from './AlmaX';
import CohortHistory from './CohortHistory';
import Certificate from './Certificate';

import { useLocation } from 'react-router-dom';
import Tracks from './Tracks';
import Mentorship from './Mentorship';
import { updateUserProgress } from '../../../../../services/apiService';
import { toast } from 'react-toastify';
import ShortCourses from './ShortCourses';

const sideMenu = [
  'Module',
  'Lesson',
  'Quiz Assessment',
  'Capstone Project',
  'Coding Assessment',
  'Assignment',
  'AlmaX Eligibility',
  'Cohort Change History',
  'Certificates',
  'Tracks',
  'Mentorship',
  'Short Courses',
];

function Progress() {
  const location = useLocation();

  const [current, setCurrent] = useState(0);
  const [userParams, setUserParams] = useState(null);

  const getGoalType = (courseType) => {
    if (courseType === 'data-engineering') return 'dataEngineering';
    if (courseType === 'data-science') return 'dataScience';
    if (courseType === 'web3') return 'web3';
    return null;
  };

  useEffect(() => {
    const userParams = location.state.userParams;
    setUserParams(userParams);
  }, []);

  const calculateProgress = async () => {
    try {
      console.log("userParamsuserParamsuserParams",userParams);
      const goalType= getGoalType(userParams?.UserSubscriptions_courseType);
      const userId= userParams?.id;

      await updateUserProgress(
        goalType,
        userId
      );
      toast.success('updating user progress');

    } catch (err) {
      console.error(err);
      toast.error('Failed to update progress');
    }
  };

  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 32 }}>
        {/* sidebar */}
        <div style={{ width: 240 }}>
          <div
            style={{
              backgroundColor: 'var(--card-background, #fff)',
              borderRadius: 16,
              padding: '8px 0',
              border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
              boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
            }}
          >
            {sideMenu.map((items, index) => (
              <div key={index}>
                <div
                  style={{
                    padding: '12px 16px',
                    fontSize: 13,
                    fontWeight: current === index ? 600 : 400,
                    color: current === index ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
                    cursor: 'pointer',
                    borderLeft: current === index ? '3px solid var(--primary-main, #4F46E5)' : '3px solid transparent',
                    backgroundColor: current === index ? 'var(--active-background, #EEF2FF)' : 'transparent',
                    transition: 'all 150ms ease',
                  }}
                  onClick={() => {
                    setCurrent(index);
                  }}
                >
                  {items}
                </div>
                {index < sideMenu.length - 1 && (
                  <div style={{ height: 1, backgroundColor: 'var(--border-light, rgba(0,0,0,0.05))', margin: '0 16px' }} />
                )}
              </div>
            ))}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div>
            <button
              onClick={calculateProgress}
              style={{
                padding: '8px 14px',
                borderRadius: 4,
                border: 'none',
                background: 'var(--primary-main, #4F46E5)',
                color: 'var(--primary-contrast, #fff)',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: 600,
                boxShadow: 'var(--shadow-primary-button, 0 2px 8px rgba(79,70,229,0.25))',
              }}
            >
              Calculate Progress
            </button>
          </div>
          <div className='w-full'>
            {current === 0 && (
              <Module
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 1 && (
              <Lesson
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 2 && (
              <QuizAssessment
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 3 && (
              <CapstoneProject
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 4 && (
              <CodingAssessment
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>

          <div>
            {current === 5 && (
              <Assignment
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 6 && (
              <AlmaX
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 7 && <CohortHistory userId={userParams?.id} />}
          </div>
          <div>
            {current === 8 && (
              <Certificate
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 9 && (
              <Tracks
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 10 && (
              <Mentorship
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
          <div>
            {current === 11 && (
              <ShortCourses
                goalType={getGoalType(userParams?.UserSubscriptions_courseType)}
                userId={userParams?.id}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Progress;
